import React from "react";
import Stories from "../Stories/Stories";
import "./SideFeed.css";

const SideFeed = () => {
  return (
    <section className="sideFeed bg-white br-5">
      <Stories />
    </section>
  );
};

export default SideFeed;
